import { ApprovalType, ComiteeType } from 'lib/api/approvals/types';
import React, { createContext, ReactNode, useContext, useState } from 'react';

interface ComiteeTabContextValue {
  requestType: ApprovalType;
  comiteeType: ComiteeType;
  requestId: number;
  canEdit: boolean;
  isRejected: boolean;
  isActive: boolean;
  comiteeId?: number;
  setComiteeId: (id?: number) => void;
  selectedRoleId?: number;
  setSelectedRoleId: (id?: number) => void;
  refreshRequest: () => Promise<void>;
}

export const ComiteeTabContext = createContext<ComiteeTabContextValue | null>(
  null,
);

interface ComiteeTabProviderProps {
  children: ReactNode;
  info: {
    requestType: ApprovalType;
    comiteeType: ComiteeType;
    requestId: number;
    comiteeId?: number;
    canEdit: boolean;
    isRejected: boolean;
    isActive: boolean;
    refreshRequest: () => Promise<void>;
  };
}

export const ComiteeTabProvider: React.FC<ComiteeTabProviderProps> = ({
  children,
  info,
}) => {
  const [selectedRoleId, setSelectedRoleId] = useState<number>();
  const [comiteeId, setComiteeId] = useState(info.comiteeId);

  return (
    <ComiteeTabContext.Provider
      value={{
        ...info,
        comiteeId,
        setComiteeId,
        selectedRoleId,
        setSelectedRoleId,
      }}
    >
      {children}
    </ComiteeTabContext.Provider>
  );
};

export const useComiteeTabContext = (): ComiteeTabContextValue => {
  const context = useContext(ComiteeTabContext);

  if (!context) {
    throw new Error(
      'useComiteeTabContext must be used within a ComiteeTabProvider',
    );
  }

  return context;
};
